import React, { useEffect, useState, useContext } from "react";
import { Button, Form, Modal, Row, Col, Spinner } from "react-bootstrap";
import "./AddEditRoleMaster.css"
import { getAllUsers, AddNewUser, UpdateUser, getValidUserData } from "../../services/user-service";
import { getCurrentDateTime, RenderIf } from "../../functions/common-functions.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { BiSelectMultiple } from "react-icons/bi";
import SingleValuePopUp from "../utils/SingleValuePopUp";
import MultiValuePopUp from "../utils/MultiValuePopUp";
import { encryptData } from "../../utils/encryption";
import { AuthContext } from "../../contexts/AuthContext";
import { addLogDetails } from "../../services/logger-entry-service";
import { isEmail, isMobNumber, isAlphanumeric, isAlphanumericWithSpace } from "../../functions/validations";
import { ALERT_PARAMS } from "../../utils/constant.js";

const AddEditUserMaster = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = {
        email: context.userEmail,
        userName: context.userName,
        userId: context.userId,
    };
    let action = props.action;
    const [toggleClass, setToggleClass] = useState("activeToggleLabel");
    const [showForm, setShowForm] = useState(false);
    const UserPopUp = "HRIS Details";
    const RolePopUp = "Role Master";
    const CustomerPopUp = "Customer Master";
    const LocationPopUp = "Location Master";
    const [ShowMobileNo, setShowMobileNo] = useState(
        !(action === "Edit")
    );
    const [loading, setLoading] = useState(false);

    const [error, setError] = useState({
        UserType: false,
        UserId: false,
        UserIdMessage: "",
        UserName: false,
        UserNameMessage: "",
        RoleDescription: false,
        RoleCode: false,
        Division: false,
        Location: false,
        BPCode: false,
        EmailId: false,
        MobileNo: false,
        AlternateMobileNo: false,
        DeleteIndication: false
    });

    const [userObj, setUserObj] = useState(
        action === "Edit"
            ? props.rowdata
            : {
                UserType: "Godrej Employee",
                UserId: "",
                UserName: "",
                RoleDescription: "",
                RoleCode: "",
                Division: "",
                Location: "",
                BPCode: "",
                EmailId: "",
                MobileNo: "",
                AlternateMobileNo: "",
                DeleteIndication: "Active",
            }
    );

    useEffect(() => {
        if (action === "Edit" && userObj.UserType === "Godrej Employee") {
            handleDivisionChange(props.rowdata.Division);
        }
    }, [action, props.rowdata]);

    const handleDivisionChange = async (division) => {
        const data = await getValidUserData("HRISuserData", "EmpEmailId", userObj.UserId?.trim())
        const newDivision = data.length > 0 ? data[0].EmpDivision : "";
        const originalDivision = division;
        if (originalDivision && newDivision !== originalDivision) {
            MySwal.fire({
                html: `Employee is transferred from <strong>${originalDivision}</strong> to <strong>${newDivision}</strong>.<br/>Kindly validate and make necessary changes.`,
                confirmButtonText: "Ok",
                cancelButtonText: "Cancel",
                title: "Division Change Detected",
                ...ALERT_PARAMS,
            }).then(async (result2) => {
                if (result2.isConfirmed) {
                    setUserObj((prevState) => ({
                        ...prevState,
                        Division: newDivision,
                        DeleteIndication: "Inactive",
                    }));
                }
            });
        }
    }

    useEffect(() => {
        if (action === "Edit" || action === "View") {
            if (props.rowdata.DeleteIndication === "Active") {
                setToggleClass("activeToggleLabel");
            } else {
                setToggleClass("inactiveToggleLabel");
            }
        }
    }, []);

    const validateDetails = async () => {
        const errorMsg = {
            UserType: false,
            UserId: false,
            UserIdMessage: "",
            UserName: false,
            UserNameMessage: "",
            RoleDescription: false,
            RoleCode: false,
            Location: false,
            BPCode: false,
            EmailId: false,
            MobileNo: false,
            AlternateMobileNo: false,
            DeleteIndication: false
        };

        let isError = false;

        if (!userObj.UserType?.trim()) {
            isError = true;
            errorMsg.UserType = true;
        }
        if (userObj.UserId?.trim() && userObj.UserType === "Godrej Employee") {
            const data = await getValidUserData("HRISuserData", "EmpEmailId", userObj.UserId?.trim())

            if (data.length <= 0) {
                isError = true;
                userObj.EmailId = "";
                userObj.EmpCode = "";
                userObj.MobileNo = "";
                errorMsg.UserId = true;
                errorMsg.UserIdMessage = "User Not Found"

            }
        }
        if (userObj.UserId?.trim() !== "" && userObj.UserType === "Customer") {
            let validateUserId = isAlphanumeric(userObj.UserId)
            if (validateUserId.status) {
                isError = true;
                errorMsg.UserId = true;
                errorMsg.UserIdMessage = validateUserId.message;
            }
        }

        if (userObj.UserType === "Godrej Employee" && !userObj.Location?.trim()) {
            isError = true;
            errorMsg.Location = true;
        }

        if (userObj.UserType === "Customer" && !userObj.BPCode?.trim()) {
            isError = true;
            errorMsg.BPCode = true;
        }

        if (userObj.RoleDescription?.trim() !== "") {
            const data = await getValidUserData("RoleMaster", "RoleDescription", userObj.RoleDescription?.trim())

            if (data.length <= 0) {
                isError = true;
                userObj.RoleCode = "";
                errorMsg.RoleDescription = true;
            }
        }

        if (isEmail(userObj.EmailId).status) {
            isError = true;
            errorMsg.EmailId = true;
        }

        if (isMobNumber(userObj.MobileNo + "")) {
            isError = true;
            errorMsg.MobileNo = true;
        }

        if (userObj.AlternateMobileNo?.trim() && isMobNumber(userObj.AlternateMobileNo + "")) {
            isError = true;
            errorMsg.AlternateMobileNo = true;
        }

        if (userObj.DeleteIndication === "") {
            isError = true;
            errorMsg.DeleteIndication = true;
        }
        setError(errorMsg)
        return isError;
    }
    const [popUp, setPopUp] = useState({
        name: "",
        type: "",
        key: "",
        value: "",
    });
    const setPopUpData = (data) => {
        if (data.name === UserPopUp) {
            setUserObj((prevState) => ({
                ...prevState,
                UserId: data.result.EmpEmailId,
                EmpCode: data.result.EmpCode.toString(),
                UserName: data.result.EmpShortName,
                Division: data.result.EmpDivision,
                EmailId: data.result.EmpEmailId + "@godrej.com",
                MobileNo: data.result.EmpMobileNo,
            }));

            setError((prevState) => ({
                ...prevState,
                UserId: false,
                EmailId: false,
                UserName: false,
                MobileNo: false,
                UserIdMessage: "",
                UserNameMessage: ""
            }));
        }
        if (data.name === RolePopUp) {
            setUserObj((prevState) => ({
                ...prevState,
                RoleCode: data.result.RoleCode,
                RoleDescription: data.result.RoleDescription

            }));
            setError((prevState) => ({
                ...prevState,
                RoleDescription: false,
            }));
        }

        if (data.name === CustomerPopUp) {
            const CustomerCodes = data.result.map(item => item.CustomerCode).join(", ");
            setUserObj((prevState) => ({
                ...prevState,
                BPCode: CustomerCodes,
            }));
            setError((prevState) => ({
                ...prevState,
                BPCode: false,
            }));
        }
        let arr = data.name.split(":");
        let masterName = arr[0];
        if (masterName === LocationPopUp) {
            const Locations = data.result.map(item => item.Location).join(", ");
            setUserObj((prevState) => ({
                ...prevState,
                Location: Locations,
            }));
            setError((prevState) => ({
                ...prevState,
                Location: false,
            }));
        }
    }


    const showPopUp = (name, type, key, value) => {
        setPopUp({ name, type, key, value });
        setShowForm(true);
    };

    const checkValidData = async (e) => {
        const { name, value } = e.target;
        if ((action !== "View")) {
            if (value.trim() === "") {
                if (name === "UserId") {
                    setUserObj((prevState) => ({
                        ...prevState,
                        UserId: "",
                        EmailId: "",
                        EmpCode: "",
                        UserName: "",
                        MobileNo: "",

                    })
                    )
                    setError((prevState) => ({
                        ...prevState,
                        UserId: false,
                        EmailId: false,
                        UserName: false,
                        MobileNo: false,
                        UserIdMessage: "",
                        UserNameMessage: ""
                    }));

                }
                if (name === "RoleDescription") {
                    setUserObj((prevState) => ({
                        ...prevState,
                        RoleCode: "",
                        RoleDescription: "",
                    })
                    )
                    setError((prevState) => ({
                        ...prevState,
                        RoleDescription: false,
                    }));
                }
            }
            else {
                setLoading(true);
                if (name === "UserId" && userObj.UserType === "Godrej Employee" && action === "Add") {
                    const data = await getValidUserData("HRISuserData", "EmpEmailId", value.trim())
                    if ((data.length > 0)) {
                        setUserObj((prevState) => ({
                            ...prevState,
                            UserName: data[0].EmpShortName,
                            EmpCode: data[0].EmpCode.toString(),
                            Division: data[0].EmpDivision,
                            EmailId: data[0].EmpEmailId + "@godrej.com",
                            MobileNo: data[0].EmpMobileNo
                        })
                        )
                        setError((prevState) => ({
                            ...prevState,
                            UserId: false,
                            EmailId: false,
                            UserName: false,
                            MobileNo: false,
                            UserIdMessage: "",
                            UserNameMessage: ""
                        }));

                        // return;
                    } else {
                        setUserObj((prevState) => ({
                            ...prevState,
                            // UserId: "",
                            EmailId: "",
                            EmpCode: "",
                            UserName: "",
                            Division: "",
                            MobileNo: "",

                        })
                        )

                        setError((prevState) => ({
                            ...prevState,
                            UserId: true,
                            UserIdMessage: "User Not Found",
                        }));
                    }
                }
                // if (name === "CustomerCode") {
                //     const data = await getValidUserData(
                //         "CompanyMaster",
                //         "CustomerCode",
                //         value.trim()
                //     );

                //     if (data.length > 0) {
                //         setUserObj((prevState) => ({
                //             ...prevState,
                //             CustomerCode: data[0].CustomerCode,
                //         }));
                //         setError((prevState) => ({
                //             ...prevState,
                //             CustomerCode: false,
                //         }));

                //         // return;
                //     } else {
                //         setUserObj((prevState) => ({
                //             ...prevState,
                //             CustomerCode: "",
                //         }));

                //         setError((prevState) => ({
                //             ...prevState,
                //             CustomerCode: true,
                //         }));
                //     }
                // }
                if (name === "RoleDescription") {
                    const data = await getValidUserData("RoleMaster", "RoleDescription", value.trim())

                    if ((data.length > 0)) {
                        setUserObj((prevState) => ({
                            ...prevState,
                            RoleCode: data[0].RoleCode,
                            RoleDescription: data[0].RoleDescription,
                        })
                        )
                        setError((prevState) => ({
                            ...prevState,
                            RoleCode: false,
                            RoleDescription: false,
                        }));

                        // return;
                    } else {
                        setUserObj((prevState) => ({
                            ...prevState,
                            RoleCode: "",
                            RoleDescription: "",
                        }));

                        setError((prevState) => ({
                            ...prevState,
                            RoleCode: true,
                            RoleDescription: true,
                        }));
                    }
                }
                setLoading(false);
            }
        }

    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "UserType") {
            setUserObj((prevState) => ({
                ...prevState,
                UserId: "",
                UserName: "",
                RoleCode: "",
                RoleDescription: "",
                Division: "",
                Location: "",
                BPCode: "",
                EmailId: "",
                MobileNo: "",
                AlternateMobileNo: "",
            })
            )
            setError((prevState) => ({
                ...prevState,
                UserId: false,
                UserIdMessage: "",
                UserName: false,
                UserNameMessage: "",
                RoleCode: false,
                RoleDescription: false,
                Division: false,
                Location: false,
                BPCode: false,
                EmailId: false,
                MobileNo: false,
                AlternateMobileNo: false,
            })
            )
        }
        setUserObj((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleCancel = () => {
        props.onHide();
    };

    const handleReset = () => {
        if (action === "Add") {
            setUserObj((prevState) => ({
                ...prevState,
                UserType: "Godrej Employee",
                UserId: "",
                UserName: "",
                RoleDescription: "",
                RoleCode: "",
                Division: "",
                Location: "",
                BPCode: "",
                EmailId: "",
                MobileNo: "",
                AlternateMobileNo: "",
                DeleteIndication: "Active",
            }));
        } else if (action === "Edit") {
            setUserObj(props.rowdata);
        }
        setError((prevState) => ({
            ...prevState,
            UserId: false,
            UserIdMessage: "",
            UserName: false,
            UserNameMessage: "",
            RoleCode: false,
            RoleDescription: false,
            Division: false,
            Location: false,
            BPCode: false,
            EmailId: false,
            MobileNo: false,
            AlternateMobileNo: false,
        })
        )
        setToggleClass("activeToggleLabel")
    }

    const handleSwitchChange = (e) => {
        if (e.target.checked) {
            setToggleClass("activeToggleLabel");
        } else {
            setToggleClass("inactiveToggleLabel");
        }

        setUserObj((prevState) => ({
            ...prevState,
            DeleteIndication: e.target.checked ? "Active" : "Inactive",
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (action == "View") {
            props.onHide();
        } else {
            setLoading(true);
            let result;
            const validationResult = await validateDetails();

            if (!validationResult) {
                const result1 = await getAllUsers();
                if (result1.length > 0) {
                    let errMsg = "";

                    if (result1.filter((item) => ((action === "Add" || (action === "Edit" && item.UserId.toLowerCase() !== userObj.UserId.toLowerCase())) && (item.UserId.toLowerCase() === userObj.UserId.toLowerCase()))).length > 0) {
                        errMsg = errMsg + "User already exists. ";
                    }

                    if (result1.filter((item) => {
                        return (action === "Add" || (action === "Edit" && item.UserId.toLowerCase() !== userObj.UserId.toLowerCase()))
                            && (item.EmailId.toLowerCase() === userObj.EmailId.toLowerCase())
                    }).length > 0) {
                        errMsg = errMsg + "Email Id already exists. ";
                    }

                    if (result1.filter((item) => ((action === "Add" || (action === "Edit" && item.UserId.toLowerCase() !== userObj.UserId.toLowerCase())) && (item.MobileNo.toLowerCase() === userObj.MobileNo.toLowerCase()))).length > 0) {
                        errMsg = errMsg + "Mobile No already exists. ";
                    }

                    if (result1.filter((item) => ((action === "Add" || (action === "Edit" && item.UserId.toLowerCase() !== userObj.UserId.toLowerCase())) && item.AlternateMobileNo && userObj.AlternateMobileNo && (item.AlternateMobileNo.toLowerCase() === userObj.AlternateMobileNo.toLowerCase()))).length > 0) {
                        errMsg = errMsg + "Alternate Mobile No already exists. ";
                    }

                    if (errMsg !== "") {
                        setLoading(false);
                        MySwal.fire({
                            text: errMsg,
                            imageUrl: errorImage,
                            customClass: "swal-success",
                        });
                        return;
                    }
                }

                setLoading(false);
                let confirmBoxText = "";
                let confirmButtonText = "";
                if (action === "Add") {
                    confirmBoxText = "Are you sure, do you want to add new User?";
                    confirmButtonText = "Add";
                } else if (action == "Edit") {
                    confirmBoxText = "Are you sure, do you want to update User?";
                    confirmButtonText = "Update";
                }

                MySwal.fire({
                    text: confirmBoxText,
                    confirmButtonText: confirmButtonText,
                    title: action + " User",
                    ...ALERT_PARAMS,
                }).then(async (result2) => {
                    if (result2.isConfirmed) {
                        setLoading(true);
                        let tempObj = Object.assign({}, userObj);

                        let maskeduserName = encryptData(userObj.UserName, "enc");
                        let maskeduserEmail = encryptData(userObj.EmailId, "enc");
                        let maskeduserMobile = encryptData(userObj.MobileNo, "enc");
                        let maskeduserAltMobile = userObj.AlternateMobileNo ? encryptData(userObj.AlternateMobileNo, "enc") : "";

                        tempObj.UserName = maskeduserName;
                        tempObj.EmailId = maskeduserEmail;
                        tempObj.MobileNo = maskeduserMobile;
                        tempObj.AlternateMobileNo = maskeduserAltMobile;
                        tempObj.UserType = userObj.UserType;
                        tempObj.RoleCode = userObj.RoleCode === "" ? "Customer" : userObj.RoleCode;
                        tempObj.RoleDescription = userObj.UserType === "Customer" ? "Customer" : userObj.RoleDescription;
                        delete tempObj.RoleName;
                        let todayDate = getCurrentDateTime("-");
                        if (action === "Add") {
                            tempObj.CreatedBy = userDetails.userId;
                            tempObj.CreatedByName = userDetails.userName;
                            tempObj.CreatedOn = todayDate;
                            tempObj.ModifiedBy = userDetails.userId;
                            tempObj.ModifiedByName = userDetails.userName;
                            tempObj.ModifiedOn = todayDate;
                            tempObj.PK = "UserMaster";
                            tempObj.SK = "UserId#" + tempObj.UserId;
                        } else if (action == "Edit") {
                            tempObj.ModifiedBy = userDetails.userId;
                            tempObj.ModifiedByName = userDetails.userName;
                            tempObj.ModifiedOn = todayDate;
                        }
                        result = await AddNewUser(tempObj);
                        if (action == "Edit") {
                            result.message = "User has been updated successfully"
                        }
                        if (result.status) {
                            //For logger details  
                            let tempUnique = "SK#" + tempObj.SK;
                            let logObj = Object.assign({}, tempObj);
                            logObj.UserName = userObj.UserName;
                            logObj.EmailId = userObj.EmailId;
                            logObj.MobileNo = userObj.MobileNo;
                            logObj.UserType = userObj.UserType;
                            logObj.RoleCode = userObj.RoleCode;
                            logObj.RoleDescription = userObj.RoleDescription;
                            await addLogDetails(logObj, action, tempUnique, "UserMasterLog", userDetails, "Master")
                            setLoading(false);
                            MySwal.fire({
                                text: result.message,
                                imageUrl: successImage,
                                customClass: "swal-success",
                                didClose: () => {
                                    props.setReload(!props.reload);
                                    props.onHide();
                                    if (action === "Edit") {
                                        if (userObj.UserId === userDetails.userId) {
                                            window.location.reload();
                                        }
                                    }
                                },
                            });
                        }
                        else {
                            setLoading(false);
                            MySwal.fire({
                                text: "Unable to Process Request",
                                imageUrl: errorImage,
                                customClass: "swal-success"
                            });
                        }
                    }
                });

            }
            else {
                setLoading(false);
                return;
            }
        }
    }

    return (
        <>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal
                {...props}
                size="lg"
                backdrop="static" centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{action} User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form
                        id="usermaster"
                        name="usermaster"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                    >
                        <Row >
                            {(action === "Edit") && (<>
                                <Col md={4} xs={12}>
                                    <Row>
                                        <Col md={5} xs={6}><Form.Label className="fieldLabel">User Type </Form.Label></Col>
                                        <Col md={7} xs={6} className="p-0"><Form.Label className="fieldLabel semiBoldToggleButton">{userObj.UserType}</Form.Label></Col>
                                    </Row>
                                </Col>
                            </>
                            )}
                            {action === "Add" && (
                                <Col md={4} xs={12}>
                                    <Row>
                                        <Form.Label className="fieldLabel locationType">User Type</Form.Label>
                                    </Row>
                                    <Row>
                                        <Col md={8} xs={6}>
                                            <Form.Check className="fieldLabel locationType"
                                                type="radio"
                                                name="UserType"
                                                checked={userObj.UserType === "Godrej Employee"}
                                                onChange={(e) => { handleChange(e) }}
                                                label="Godrej Employee"
                                                value="Godrej Employee"
                                            ></Form.Check>
                                        </Col>
                                        <Col md={4} xs={6} className="p-0">
                                            <Form.Check className="fieldLabel locationType"
                                                type="radio"
                                                name="UserType"
                                                checked={userObj.UserType === "Customer"}
                                                onChange={(e) => { handleChange(e) }}
                                                label="Customer"
                                                value="Customer"
                                            ></Form.Check>
                                        </Col>
                                    </Row>
                                </Col>
                            )}
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input ">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="UserId"
                                            type="text"
                                            name="UserId"
                                            maxLength="20"
                                            placeholder=" "
                                            required
                                            value={userObj.UserId}
                                            onBlur={(e) => { checkValidData(e) }}
                                            onChange={(e) => { handleChange(e) }}
                                            onInput={(e) => {
                                                let error = isAlphanumeric(e.target.value);
                                                setError((prevState) => ({
                                                    ...prevState,
                                                    UserId: error.status,
                                                    UserEmail: error.status,
                                                    UserIdMessage: error.message
                                                }));
                                            }}
                                            readOnly={action === "Edit"} />
                                        <Form.Label className="frm-label" for="UserId">User ID</Form.Label>
                                        <BiSelectMultiple
                                            className={(userObj.UserType === "Customer") || (action === "Edit") ? "d-none" : ""}
                                            size={20}
                                            onClick={() => showPopUp(UserPopUp, "Single", "EmpEmailId", userObj.UserId)}
                                            color={"#707070"}
                                            style={{ marginLeft: "-2rem" }}
                                            backdrop="static"
                                        />
                                    </div>
                                    {error.UserId && (
                                        <Form.Text className="text-danger">
                                            {error.UserIdMessage}
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="UserName"
                                        type="text"
                                        name="UserName"
                                        maxLength="100"
                                        placeholder=" "
                                        required
                                        value={userObj.UserName}
                                        onChange={(e) => { handleChange(e) }}
                                        onInput={(e) => {
                                            let error = isAlphanumericWithSpace(e.target.value);
                                            setError((prevState) => ({
                                                ...prevState,
                                                UserName: error.status,
                                                UserNameMessage: error.message
                                            }));
                                        }}
                                    />
                                    <Form.Label className="frm-label" for="UserName">User Name</Form.Label>
                                    {error.UserName && (
                                        <Form.Text className="text-danger">
                                            {error.UserNameMessage}
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="EmpDivision"
                                        type="text"
                                        name="Division"
                                        placeholder=" "
                                        value={userObj.Division}
                                        readOnly
                                    />
                                    <Form.Label className="frm-label" htmlFor="Division">Division</Form.Label>
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="Location"
                                            type="text"
                                            name="Location"
                                            placeholder=" "
                                            value={userObj.Location}
                                            onChange={(e) => { handleChange(e) }}
                                            //readOnly={userObj.UserType === "Customer" || !userObj.Division}
                                            readOnly={true}
                                        />
                                        <Form.Label className="frm-label" for="Location">Location</Form.Label>
                                        <BiSelectMultiple
                                            className={(userObj.UserType === "Customer") || (action === "View") || (!userObj.Division) ? "d-none" : ""}
                                            size={20}
                                            onClick={() => showPopUp(`Location Master:${userObj.Division}`, "Multiple", "Location", userObj.Location)}
                                            color={"#707070"}
                                            style={{ marginLeft: "-2rem" }}
                                            backdrop="static"
                                        />
                                    </div>
                                    {error.Location && (
                                        <Form.Text className="text-danger">
                                            Please select at least one Location.
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="RoleDescription"
                                            type="text"
                                            name="RoleDescription"
                                            placeholder=" "
                                            required
                                            value={userObj.UserType === "Customer" ? "Customer" : userObj.RoleDescription}
                                            onBlur={(e) => { checkValidData(e) }}
                                            onChange={(e) => { handleChange(e) }}
                                            // readOnly={action === "View" || userObj.UserType === "Customer"}
                                            readOnly
                                        />
                                        <Form.Label className="frm-label" for="RoleDescription">Role</Form.Label>
                                        <BiSelectMultiple
                                            className={(action === "View" || userObj.UserType === "Customer") ? "d-none" : ""}
                                            size={20}
                                            onClick={() => showPopUp(RolePopUp, "Single", "RoleDescription", userObj.Code)}
                                            color={"#707070"}
                                            style={{ marginLeft: "-2rem" }}
                                            backdrop="static"
                                        />
                                    </div>
                                    {error.RoleDescription && (
                                        <Form.Text className="text-danger">
                                            Enter Valid Role Name.
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <div className="d-flex align-items-center">
                                        <Form.Control
                                            id="CustomerCode"
                                            type="text"
                                            name="CustomerCode"
                                            placeholder=" "
                                            value={userObj.BPCode}
                                            onChange={(e) => { handleChange(e) }}
                                            readOnly={userObj.UserType === "Godrej Employee"}
                                        />
                                        <Form.Label className="frm-label" for="CustomerCode">BP Code</Form.Label>
                                        <BiSelectMultiple
                                            className={(userObj.UserType === "Godrej Employee") || (action === "View") ? "d-none" : ""}
                                            size={20}
                                            onClick={() => showPopUp("Customer Master", "Multiple", "CustomerCode", userObj.BPCode)}
                                            color={"#707070"}
                                            style={{ marginLeft: "-2rem" }}
                                            backdrop="static"
                                        />
                                    </div>
                                    {error.CustomerCode && (
                                        <Form.Text className="text-danger">
                                            Please select at least one BP Code.
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="EmailId"
                                        type="text"
                                        name="EmailId"
                                        maxLength="100"
                                        placeholder=" "
                                        required
                                        value={userObj.EmailId}

                                        onChange={(e) => { handleChange(e) }}
                                        onBlur={(e) => {
                                            let error = isEmail(e.target.value);
                                            setError((prevState) => ({
                                                ...prevState,
                                                EmailId: error.status,
                                            }));
                                        }}
                                        readOnly={(userObj.UserType === "Godrej Employee")}
                                    />
                                    <Form.Label className="frm-label" for="EmailId">Email ID</Form.Label>
                                    {error.EmailId && (
                                        <Form.Text className="text-danger">
                                            {userObj.UserType === "Customer" && userObj.EmailId?.toLowerCase().includes('@godrej.com')
                                                ? "Customer cannot have @godrej.com email ID."
                                                : "Enter valid Email Id."}
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="MobileNo"
                                        type="text"
                                        name="MobileNo"
                                        maxLength="10"
                                        placeholder=" "
                                        required
                                        value={userObj.MobileNo}
                                        onClick={() => setShowMobileNo(false)}
                                        onChange={(e) => { handleChange(e) }}
                                        onBlur={(e) => {
                                            let error = isMobNumber(e.target.value);
                                            setError((prevState) => ({
                                                ...prevState,
                                                MobileNo: error,
                                            }));
                                            userObj.MobileNo ?
                                                setShowMobileNo(false) : setShowMobileNo(true)
                                        }}
                                    />
                                    <Form.Label className="frm-label" for="MobileNo">Mobile Number</Form.Label>
                                    {error.MobileNo && (
                                        <Form.Text className="text-danger">
                                            Enter valid Mobile Number with 10 digits
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col md={4} xs={12}>
                                <Form.Group className="g-input">
                                    <Form.Control
                                        id="AlternateMobileNo"
                                        type="text"
                                        name="AlternateMobileNo"
                                        maxLength="10"
                                        placeholder=" "
                                        value={userObj.AlternateMobileNo}
                                        onChange={(e) => { handleChange(e) }}
                                        onBlur={(e) => {
                                            if (e.target.value.trim()) {
                                                let error = isMobNumber(e.target.value);
                                                setError((prevState) => ({
                                                    ...prevState,
                                                    AlternateMobileNo: error,
                                                }));
                                            } else {
                                                setError((prevState) => ({
                                                    ...prevState,
                                                    AlternateMobileNo: false,
                                                }));
                                            }
                                        }}
                                    />
                                    <Form.Label className="frm-label" for="AlternateMobileNo">Alternate Mobile Number</Form.Label>
                                    {error.AlternateMobileNo && (
                                        <Form.Text className="text-danger">
                                            Enter valid Alternative Mobile Number with 10 digits
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>

                            <Col md={4} xs={12}>
                                <Row>
                                    <Col>
                                        <Form.Label className="fieldLabel">Status</Form.Label>
                                    </Col>
                                    <Col>
                                        <Form.Switch
                                            className={"semiBoldToggleButton " + toggleClass}
                                            label={
                                                userObj.DeleteIndication === "Active"
                                                    ? "Active"
                                                    : "Inactive"
                                            }
                                            name="DeleteIndication"
                                            checked={userObj.DeleteIndication === "Active"}
                                            onChange={(e) => {
                                                handleSwitchChange(e);
                                            }}
                                            disabled={action === "View"}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={9} xs={6}>
                                <Row>
                                    <Col md={3} xs={12}>
                                        <Button
                                            className="semiBoldToggleButton cancelBtn"
                                            variant="outline-success"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </Button>
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <Button
                                            className="resetBtn semiBoldToggleButton"
                                            variant="link"
                                            onClick={handleReset}
                                        >
                                            Reset Fields
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3} xs={6}>
                                <Button
                                    variant="success"
                                    className="btn-add-color semiBoldToggleButton rightAlignedButton"
                                    type="submit"
                                >
                                    {action === "Edit" ? "Update" : "Add"}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>
            {/* <RenderIf isTrue={popUp.type === "Single" && showForm}>
                    <MultiValuePopUp
                        show={showForm}
                        onHide={() => setShowForm(false)}
                        setSelected={setPopUpData}
                        selectionType={popUp.type.toLowerCase()}
                        masterName={popUp.name}
                        paramkey={popUp.key}
                        paramvalue={popUp.value}
                    //    locationData={companydivisionObj.CompanyCountry}
                    />
                </RenderIf> */}
            <RenderIf isTrue={popUp.type === "Single" && showForm}>
                <SingleValuePopUp
                    show={showForm}
                    onHide={() => setShowForm(false)}
                    setSelected={setPopUpData}
                    selectionType={popUp.type.toLowerCase()}
                    mastername={popUp.name}
                    paramkey="RoleDescription"
                    paramvalue={popUp.value}
                />
            </RenderIf>
            <RenderIf isTrue={popUp.type === "Multiple" && showForm}>
                <MultiValuePopUp
                    show={showForm}
                    onHide={() => setShowForm(false)}
                    setSelected={setPopUpData}
                    masterName={popUp.name}
                    selectedItems={popUp.value}
                />
            </RenderIf>
        </>
    );
}

export default AddEditUserMaster;
